'use client'

import Link from 'next/link'
import { useEffect } from 'react'
import { Button } from "@/components/ui/button"
import { H1 } from '@/components/site/primitives'
import { reportClientError } from '@/lib/observability/client-errors'

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
    reportClientError(error)
  }, [error])

  return (
    <main className="mx-auto max-w-2xl px-4 py-16 text-center">
      <H1 className="text-xl text-foreground">This page didn’t load</H1>
      <div className="mt-6 flex justify-center gap-3">
        <Button
          type="button"
          onClick={reset}
          className="rounded-lg border border-border bg-card px-4 py-2 text-sm font-medium text-muted-foreground shadow-sm hover:bg-muted"
        >
          Try again
        </Button>
        <Link href="/" className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90">
          Go home
        </Link>
      </div>
    </main>
  )
}
